export default {
  sidebar: [
    {
      name: '1. Basic',
      path: 'basic',
      icon: 'basic'
    },
    {
      name: '2. Social',
      path: 'social',
      icon: 'social'
    },
    {
      name: '3. Custom',
      path: 'addons',
      icon: 'custom'
    }
  ]
}